import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { AlertDismissable } from 'common/components/Alert';
import { kybT1InProgress, kybT1Submitted } from 'common/constants';

const OffRampsAlerts = ({ complianceStatus }) => {
  const verifying = useMemo(
    () => [kybT1InProgress, kybT1Submitted].includes(complianceStatus),
    [complianceStatus]
  );

  const [visible, setVisible] = useState(true);
  if (!visible || !verifying) return null;

  return (
    <AlertDismissable
      text={[
        'Off ramps are not enabled yet.',
        <br key="break" />,
        `You'll get an email once we verify your business documents.`,
      ]}
      buttonText="Dismiss"
      onDismiss={() => setVisible(false)}
    />
  );
};

OffRampsAlerts.propTypes = {
  complianceStatus: PropTypes.string,
};

export default OffRampsAlerts;
